export var BannerSize;
(function (BannerSize) {
    BannerSize["BANNER"] = "BANNER";
    BannerSize["LARGE_BANNER"] = "LARGE_BANNER";
    BannerSize["MEDIUM_RECTANGLE"] = "MEDIUM_RECTANGLE";
    BannerSize["FULL_BANNER"] = "FULL_BANNER";
    BannerSize["LEADERBOARD"] = "LEADERBOARD";
})(BannerSize || (BannerSize = {}));
export var BannerPosition;
(function (BannerPosition) {
    BannerPosition["TOP"] = "top";
    BannerPosition["BOTTOM"] = "bottom";
})(BannerPosition || (BannerPosition = {}));
//# sourceMappingURL=definitions.js.map